import "./Bienvenida.css";

export default function Bienvenida() {
  return (
    <section className="bienvenida">
      <div className="contenedor-texto">
      </div>
    </section>
  );
}
